import React, { ReactElement, useState } from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';
import queryString from 'query-string';
import { adminState, userState } from 'app-state/user-state';
import { Button } from 'components/common/Button';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShoppingCart, faUser, faHome, faShoppingBag, faPhoneAlt } from '@fortawesome/free-solid-svg-icons';

import logo from 'assets/images/JPLogo.svg';
import { cartState } from 'app-state/cart-state';
import SearchField from 'components/common/SearchField';
import { useRecoilState, useRecoilValue } from 'recoil';
import LoginModal from 'components/common/modals/LoginModal';
import ConfirmationModal from 'components/common/modals/ConfirmationModal';

const Header = (): ReactElement => {
  const { cartItemCount } = useRecoilValue(cartState);
  const [userName, setUserName] = useRecoilState(userState);
  const isAdmin = useRecoilValue(adminState);
  const history = useHistory();
  const { search: queryParams } = useLocation();
  const params = queryString.parse(queryParams);
  const [searchTerm, setSearchTerm] = useState(params.search as string | null);
  const [loginModalIsOpen, setLoginModalIsOpen] = useState(false);
  const [logoutModalIsOpen, setLogoutModalIsOpen] = useState(false);

  const onSubmitSearch = () => {
    history.push(`/shop?search=${searchTerm}`);
  };

  const linkClasses = 'transition duration-50 ease-in-out hover:text-secondary transform hover:-translate-y-1 '
    + 'hover:scale-80 hover:border-secondary border-transparent border-b-2 px-4';

  return (<React.Fragment>
    <div id="web-warning" className=" bg-gray-100 py-2 text-secondary">
      Warning: This website is only to be used used for training purposes.
    </div>
    <nav className="header bg-white shadow inset-x-0 bottom-0 w-full">
      <div className="container w-full mx-auto px-4">
        <div className="flex justify-between">
          <div className="flex space-x-4">
            <div>
              <Link to="/" className="flex items-center" id='jupiterprime-logo' aria-label='Jupiter Prime Home'>
                <img alt="Jupiter Prime Logo" title="Jupiter Prime Home" src={logo} />
              </Link>
            </div>
            <div className="hidden md:flex items-center space-x-5">
              <Link to="/" id="menu-home" className={linkClasses}>
                <FontAwesomeIcon className="mx-2" icon={faHome} />Home
              </Link>
              <Link to="/shop" id="menu-shop" className={linkClasses}>
                <FontAwesomeIcon className="mx-2" icon={faShoppingBag} />Shop
              </Link>
              <Link to="/contact" id="menu-contact" className={linkClasses}>
                <FontAwesomeIcon className="mx-2" icon={faPhoneAlt} />Contact
              </Link>
            </div>
          </div>
          <div className="hidden md:flex items-center space-x-5">
            <SearchField
              className='pt-2'
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}
              onSubmit={onSubmitSearch} />
            {userName ? <React.Fragment>
              <span id="login-greeting" className='text-lg font-bold mx-4'>Hi {userName}</span>
              <button id="menu-logout" onClick={() => setLogoutModalIsOpen(true)} className={linkClasses}>
                Log Out
              </button>
            </React.Fragment>
              : <button id="menu-login" onClick={() => setLoginModalIsOpen(true)} className={linkClasses}>Login
                <FontAwesomeIcon className="mx-2" icon={faUser} /></button>}
            {isAdmin && <Button danger id='admin-button' linkTo='/admin/products'>Admin</Button>}
            <Link id="menu-cart" to="/cart" className={linkClasses}>Cart
              <FontAwesomeIcon className="mx-2 relative" icon={faShoppingCart} />
              <span
                id='cart-count'
                aria-label="Number of items in cart"
                className="absolute bottom-3 right-1 text-s text-white bg-secondary font-bold rounded-lg px-1">
                {cartItemCount}
              </span>
            </Link>

          </div>
          <div className="md:hidden flex items-center">
            <button id="mobile-menu-button" aria-label="Menu">
              <svg className="w-6 h-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </nav>

    <LoginModal isOpen={loginModalIsOpen} setIsOpen={setLoginModalIsOpen} />
    <ConfirmationModal
      id="logout-modal"
      heading="Are you sure that you want to logout?"
      isOpen={logoutModalIsOpen}
      onConfirm={() => {
        setUserName(undefined);
        setLogoutModalIsOpen(false);
      }}
      onCancel={() => setLogoutModalIsOpen(false)}
    />
  </React.Fragment>
  );
};
export default Header;
